<div (click)="goBack.emit()" class="addCursor">
	<div nz-row nzAlign="middle">
		<div>
			<div class="pos-relative back-icon">
				<ng-content select="[backIcon]"></ng-content>
				<svg *ngIf="showDefaultIcon" fill="none" height="19" viewBox="0 0 19 19" width="19"
					 xmlns="http://www.w3.org/2000/svg">
					<g clip-path="url(#clip0_4751_215973)">
						<path
							d="M17.8125 8.31241H4.54813L10.3431 2.51741C10.8063 2.05429 10.8063 1.29429 10.3431 0.831164C10.2333 0.721078 10.1028 0.63374 9.95912 0.57415C9.81546 0.51456 9.66146 0.483887 9.50594 0.483887C9.35041 0.483887 9.19642 0.51456 9.05276 0.57415C8.9091 0.63374 8.77861 0.721078 8.66875 0.831164L0.843127 8.65679C0.733042 8.76665 0.645704 8.89714 0.586113 9.0408C0.526523 9.18445 0.49585 9.33845 0.49585 9.49398C0.49585 9.6495 0.526523 9.8035 0.586113 9.94716C0.645704 10.0908 0.733042 10.2213 0.843127 10.3312L8.66875 18.1568C8.77869 18.2667 8.90921 18.3539 9.05286 18.4134C9.1965 18.4729 9.35046 18.5036 9.50594 18.5036C9.66142 18.5036 9.81538 18.4729 9.95902 18.4134C10.1027 18.3539 10.2332 18.2667 10.3431 18.1568C10.4531 18.0469 10.5403 17.9163 10.5998 17.7727C10.6593 17.629 10.6899 17.4751 10.6899 17.3196C10.6899 17.1641 10.6593 17.0102 10.5998 16.8665C10.5403 16.7229 10.4531 16.5924 10.3431 16.4824L4.54813 10.6874H17.8125C18.4656 10.6874 19 10.153 19 9.49992C19 8.84679 18.4656 8.31241 17.8125 8.31241Z"
							fill="#0361F0"/>
					</g>
					<defs>
						<clipPath id="clip0_4751_215973">
							<rect fill="white" height="19" width="19"/>
						</clipPath>
					</defs>
				</svg>
			</div>
		</div>
		<div>
			<div class="m-l-15">
				<div class="web-view-back-btn {{textColor}}">
					{{buttonName}}
				</div>
			</div>
		</div>
	</div>
</div>
